import StandCategoryContainer from "../../../Component/Application/StandCategory/StandCategoryContainer";

const StandCategory = () => {
  return (
    <div className='page-body'>
      <StandCategoryContainer />
    </div>
  );
};

export default StandCategory;